import React from 'react';
import {DocumentIcon, Pencil} from "assets/icons";
import BadgeSquare from "components/badge/badgeSquare";
import usefetchdata from "hooks/usefetchdata";

const Threeform = ({onModifyAll}) => {
    const {tempWorkerData} = usefetchdata()

    const handleModify = (e) => {
        e.preventDefault()
        onModifyAll()
    }

    const hasAccommodation = tempWorkerData?.accommodation_of_address?.validated && tempWorkerData.accommodation_of_address.validated !== "0";
    const hasHostIdentity = tempWorkerData?.hostIdentity?.validated && tempWorkerData.hostIdentity.validated !== "0";

    const getDocumentLabel = () => {
        const parts = ["Justificatif de domicile"];
        if (hasAccommodation) parts.push("Attestation d'hébergement");
        if (hasHostIdentity) parts.push("Pièce d'identité de l'hôte");
        return parts.join(" & ");
    };

    const getCombinedBadge = () => {
        const proofStatus = tempWorkerData?.proof_of_address?.validated;
        const accommodationStatus = hasAccommodation ? tempWorkerData?.accommodation_of_address?.validated : null;
        const hostIdStatus = hasHostIdentity ? tempWorkerData?.hostIdentity?.validated : null;

        const statuses = [proofStatus, accommodationStatus, hostIdStatus].filter(Boolean);
        if (statuses.includes("0")) return "0";
        if (statuses.includes("3")) return "3";
        if (statuses.includes("1")) return "1";
        return proofStatus;
    };

    return (
        <div className={'flex flex-col gap-4'}>
            <div className="flex items-center justify-between">
                <div className="flex gap-2">
                    <div className='relative my-auto bg-gray-100 w-[40px] h-[40px] flex justify-center items-center rounded-full'>
                        <DocumentIcon wh={35} color={'#111827'}/>
                    </div>
                    <div className="col-span-3 ft-b text-gray-900 my-auto">
                        {getDocumentLabel()}
                    </div>
                </div>
                <div className='col-span-1 flex'>
                    <div className='my-auto mr-2'>
                        <BadgeSquare type={getCombinedBadge()}/>
                    </div>
                    <div className='my-auto'>
                        <button onClick={handleModify} className='rounded-full w-10 h-10 flex items-center justify-center'>
                            <Pencil wh={22} color={'#374151'}/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Threeform;